import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';
function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Bringing 5G to the Vineyard </p>
        <p className="chapter__paragraph">
          In one vineyard in California’s San Joaquin Valley, a new autonomous agricultural solution
          took shape. Bluewhite already had the experience and expertise necessary to outfit the
          grower’s equipment with its robust automation kit, but they needed a connectivity solution
          that could work in the middle of the sprawling vineyard. How do you provide connectivity
          across a farm? That’s why private wireless is so important.
        </p>
        <p className="chapter__paragraph">
          Bluewhite and Intel worked with Federated Wireless, a Virginia-based company that offers
          4G/5G private wireless solutions to connect “hard to reach” communities. Together they
          created a private wireless network that broadcasts on the license-free and cloud-managed
          Citizens Broadband Radio Service (CBRS), which allows enterprises real-time connectivity,
          unlimited data usage, and unparalleled privacy. With a private network running CBRS, the
          data never has to cross the public internet or even a shared public cellular network.
        </p>
        <p className="chapter__paragraph">
          To maximize efficiency, Bluewhite deployed private wireless at the edge. The pilot program
          utilized Intel Smart Edge technology, and featured a six-core Intel Xeon D-1528
          processor-based server. According to Ascher, Smart Edge technology “improved communication
          between the robots and the operators—leading to reliable connectivity and increased
          productivity, allowing the growers to make better decisions in real-time.”
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            '“Smart Edge technology improved communication between robots and the operators — leading to reliable connectivity and increased productivity, allowing the growers to make better decisions in real-time.”'
          }
          author={'Alon Ascher,'}
          source={'Bluewhite'}
        />
      </section>
    </>
  );
}

export default Chapter6;
